import { eq } from 'drizzle-orm'
import { db } from '@/db'
import { users } from '@/db/schema'
import { normalizeSupportedLanguage, type SupportedLanguage } from '@/lib/user-language'
import { getDictionary, t } from '.'

export async function getI18nForUserId(userId: string) {
  const [user] = await db
    .select({ preferredLanguage: users.preferredLanguage })
    .from(users)
    .where(eq(users.id, userId))
    .limit(1)

  return createI18n(normalizeSupportedLanguage(user?.preferredLanguage))
}

export async function getI18nByEmail(email: string, fallbackLanguage?: string) {
  const [user] = await db
    .select({ preferredLanguage: users.preferredLanguage })
    .from(users)
    .where(eq(users.email, email.toLowerCase().trim()))
    .limit(1)

  if (user) return createI18n(normalizeSupportedLanguage(user.preferredLanguage))
  return createI18n(normalizeSupportedLanguage(fallbackLanguage))
}

export async function getI18n() {
  const { auth } = await import('@/auth')
  const session = await auth()
  if (!session?.user?.id) return createI18n('en')
  return getI18nForUserId(session.user.id)
}

export function createI18n(language: SupportedLanguage) {
  const dictionary = getDictionary(language)
  return {
    language,
    dictionary,
    t: (key: string, replacements?: Record<string, string | number>) => t(dictionary, key, replacements),
  }
}
